import React, {useState, useEffect} from 'react'
//! Styles
import './appm-2.style.css'
//! MUI
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { TextField } from '@mui/material';
//! Moment
import moment from 'moment';
import { fi } from 'date-fns/locale';
import { useParams } from 'react-router-dom';
import { DecryptedOBJ, EncryptedOBJ } from '../../utils/Encryption';


function ReAppointment_1(props) {
    const { appointId, tranid } = useParams();
    // useState
    const [dataForm, setDataForm] = useState(
        [
            {
                id: 1,
                title: 'ชื่อ / Name',
                input_type: 'text',
                input_name: 'fname',
                place_holder: 'กรอกชื่อ / Name ',
                value: ''
            },
            {
                id: 2,
                title: 'นามสกุล / Surname',
                input_type: 'text',
                input_name: 'lname',
                place_holder: 'กรอกนามสกุล / Surname',
                value: ''
            },
            {
                id: 3,
                title: 'วันเดือนปีเกิด / Date of Birth',
                input_type: 'date',
                input_name: 'dateofbirth',
                place_holder: 'dd/mm/yyyy',
                value: ''
            },
            {
                id: 4,
                title: 'เบอร์ติดต่อ / Contact Number',
                input_type: 'tel',
                input_name: 'tel',
                place_holder: 'กรอกเบอร์ติดต่อ / Contact Number',
                value: ''
            },
            {
                id: 5,
                title: 'E-mail',
                input_type: 'email',
                input_name: 'email',
                place_holder: 'กรอก E-mail',
                value: ''
            },
        ]
    )
    const [displayName, setDisplayName] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [errorStatus, setErrorStatus] = useState(false);
    // input
    const [dobDate, setDobDate] = useState([]);
    const [dobYear, setDobYear] = useState([]);
    const [daySelec, setDaySelec] = useState(null);
    const [monthSelec, setMonthSelec] = useState(null);
    const [yearSelec, setYearSelec] = useState(null);
    const [startDate, setStartDate] = useState(new Date());
    const [dob, setDob] = useState(null);
    const [tel, setTel] = useState('');
    const [months, setMonths] = useState([
        {
            id: 1,
            month_name: "มกราคม", 
            days: 31
        },
        {
            id: 2,
            month_name: "กุมภาพันธ์", 
            days: 29
        },
        {
            id: 3,
            month_name: "มีนาคม", 
            days: 31
        },
        {
            id: 4,
            month_name: "เมษายน", 
            days: 30
        },
        {
            id: 5,
            month_name: "พฤษภาคม", 
            days: 31
        },
        {
            id: 6,
            month_name: "มิถุนายน", 
            days: 30
        },
        {
            id: 7,
            month_name: "กรกฎาคม",
            days: 31
        },
        {
            id: 8,
            month_name: "สิงหาคม", 
            days: 31
        },
        {
            id: 9,
            month_name: "กันยายน", 
            days: 30
        },
        {
            id: 10,
            month_name: "ตุลาคม", 
            days: 31
        },
        {
            id: 11,
            month_name: "พฤศจิกายน", 
            days: 30
        },
        {
            id: 12,
            month_name: "ธันวาคม", 
            days: 31
        },
    ]);

    useEffect(() => {
        // clear
        if(window.localStorage.getItem('formData_page-2') !== null)
        {
            window.localStorage.removeItem('formData_page-2');
            window.location.reload();
        }
        // line profile init
        if(window.localStorage.getItem('line_profile') !== null)
        {
            setDisplayName(DecryptedOBJ(window.localStorage.getItem('line_profile')).display_name);
        }

        // Start DatePicker Droprown
        // datePickerInit();
    },[])

    //! Date Picker Init
    const datePickerInit = () => {
        // Get Element
        const dElement = document.querySelector("#appm2-ddob-d");
        const mElement = document.querySelector("#appm2-ddob-m");
        const yElement = document.querySelector("#appm2-ddob-y");
        // Get Date
        const date = moment(new Date(), "DD/MM/YYYY").format("DD/MMMM/YYYY") 
        const day = new Date().getDate();
        const month = new Date().getMonth()+1;
        const year = new Date().getFullYear();

        let dayLength = 0;
        let dayArr = [];
        let yearArr = [];

        // Default Set Day
        months.map(item => {
            if(item.id === month)
            {
                dayLength = item.days
            }
        })
        for(let i=1; i<=dayLength; i++)
        {
            dayArr.push(i)
        }
        setDobDate(dayArr);
        // Default Set Year
        for(let x=1922; x<=year; x++)
        {
            yearArr.push(x);
        }
        setDobYear(yearArr);

        mElement.value = month;
        setMonthSelec(month);
    }
    const onChangeInput = (e, id) => {
        // changed
        dataForm.map(item => {
            if(item.id === id)
            {
                item.value = e.target.value;
            }
        })
    }
    const onBack = () => {
        window.location.href = `/lab/n-health/appointHistoryDetails/${tranid}`;
    }
    const onSubmit = (e) => {
        e.preventDefault();
        // Get Element
        const dElement = document.querySelector("#appm2-ddob-d");
        const mElement = document.querySelector("#appm2-ddob-m");
        const yElement = document.querySelector("#appm2-ddob-y");

            if(dataForm[2].value !== 'Invalid date' && dataForm[2].value !== '')
            {
                if(dataForm[3].value.length < 9)
                {
                    setErrorMsg('กรุณากรอกเบอร์โทรศัทพ์ให้ครบถ้วน.');
                    setErrorStatus(true);
                }else
                {
                    setErrorMsg('');
                    setErrorStatus(false);
                    window.localStorage.setItem('reappoint-1-form', EncryptedOBJ(dataForm))
                    window.location.href = `/lab/n-health/reappointment-2/${tranid}/${appointId}`
                }
            }else
            {
                setErrorMsg('กรุณาระบุวัน/เดือน/ปีเกิด ให้ครบถ้วน.');
                setErrorStatus(true);         
            }
    }

    const validateDOB = () => {
        if(daySelec !== null && daySelec !== '' && daySelec !== 'default')
        {
            if(monthSelec !== null && monthSelec !== '' && monthSelec !== 'default')
            {

                if(yearSelec !== null && yearSelec !== '' && yearSelec !== 'default')
                {
                    return true;
                }else
                {
                    return false;
                }
            }else
            {
                return false;
            }
        }else
        {
            return false;
        }
 
    }

    const handleSetDOB = (e, type) => {
        if(type === 'day')
        {
            setDaySelec(e.target.value)
        }
        if(type === 'month')
        {
            setMonthSelec(e.target.value)
            let dayArr = [];
            let dayLength = 0;
            // Default Set Day
            months.map(item => {
                if(item.id === Number(e.target.value))
                {
                    dayLength = item.days
                }
            })
            for(let i=1; i<=dayLength; i++)
            {
                dayArr.push(i)
            }
            setDobDate(dayArr);
        }
        if(type === 'year')
        {
            setYearSelec(e.target.value);
        }
    }
    const handleSetDOBCalen = (e) => {
        setDob(e)
        dataForm[2]["value"] = moment(e, "DD/MM/YYYY").format("DD/MM/YYYY"); ;
        // console.log(dataForm[2].value)
    }

    return (
        <div className="appm-2_container">
            <div className="appm-2-form_wrapper">
                {/* header */}
                <h1 className="appm-2-form_header">ข้อมูลผู้ทำนัด</h1>

                {/* dropdown items */}
                <form onSubmit={(e) => onSubmit(e)} className="appm-2-input_wrapper">
                    {/* Fname */}
                    <div className="appm-2-input_item">
                        <span className='normal-black'>ชื่อ / Name {`(${displayName})`}</span>
                        <input 
                            name="fname"
                            className={`appm-2-input_fname`}
                            type="text"
                            // maxLength={item.input_type === 'tel' ? 10 : 100}
                            onChange={(e) => onChangeInput(e, 1)}
                            placeholder="กรอกชื่อ / Name " 
                            required
                        />
                    </div>
                    {/* Lname */}
                    <div className="appm-2-input_item">
                        <span className='normal-black'>นามสกุล / Surname</span>
                        <input 
                            name="lname"
                            className={`appm-2-input_lname`}
                            type="text"
                            // maxLength={item.input_type === 'tel' ? 10 : 100}
                            onChange={(e) => onChangeInput(e, 2)}
                            placeholder="กรอกนามสกุล / Surname " 
                            required
                        />
                    </div>
                    {/* Date Of Birth */}
                    <div className="appm-2-input_item">
                        <span className='normal-black'>วันเดือนปีเกิด / Date of Birth</span>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <MobileDatePicker
                                    label="ระบุวันเดือนปีเกิด"
                                    inputFormat="dd/MM/yyyy"
                                    // minDate={new Date('2022/08/08')}
                                    // maxDate={new Date('2022/09/30')}
                                    value={dob}
                                    onChange={(e) => handleSetDOBCalen(e)}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider> 
                    </div>
                    {/* Tel */}
                    <div className="appm-2-input_item">
                        <span className='normal-black'>เบอร์ติดต่อ / Contact Number</span>
                        <input 
                            name="tel"
                            className={`appm-2-input_tel`}
                            type="number"
                            maxLength={10}
                            value={tel}
                            onChange={(e) => {
                                if(e.target.value.length <= 10)
                                {
                                    onChangeInput(e, 4)
                                    setTel(e.target.value)
                                }
                            }}
                            placeholder="กรอกเบอร์ติดต่อ / Contact Number"
                            required
                        />
                    </div>
                    {/* Email */}
                    <div className="appm-2-input_item">
                        <span className='normal-black'>E-mail</span>
                        <input 
                            name="email"
                            className={`appm-2-input_email`}
                            type="email"
                            onChange={(e) => onChangeInput(e, 5)}
                            placeholder="กรอก E-mail"
                            required
                        />
                    </div>

                    {/* alert error */}
                    <p className="appm-2-alert_error">
                        {errorMsg}
                    </p>

                    {/* button */}
                    <div className="appm-2-button_wrapper">
                        <button 
                            className="appm-2-btn_back"
                            onClick={onBack}
                        >
                            ย้อนกลับ
                        </button>
                        <button 
                            className="appm-2-btn_submit"
                            type="submit"
                        >
                            ถัดไป
                        </button>
                    </div>
                </form>

            </div>
            {/* footer */}
            <p className="footer-text">Copyright © 2022 National Healthcare Systems Company Limited All rights reserved</p> 
        </div>
    )
}

export default ReAppointment_1